module.exports = __webpack_public_path__ + "img/popUp_menu_big.b5c6241.webp";